import styled from 'styled-components'

import Background from '../Background'
import Col from '../Col'
import Container from '../Container'
import Row from '../Row'

import Link from './Link'

const FooterBackground = styled(Background).attrs({
  as: 'footer',
  type: 'primary',
})`
  ${Col} {
    padding-top: ${props => props.theme.gutter}px;
  }

  ${Col} + ${Col} {
    flex: 1 1 100%;
  }

  ${Link} {
    color: ${props => props.theme.fontColorWithBackground[props.type]};
  }

  @media (min-width: 768px) {
    ${Container} > ${Row} {
      width: ${props => (props.width ? props.width * 100 : 100)}%;
    }

    ${Col} + ${Col} {
      flex: ${props => (props.width < 1 ? '1 1 100%' : '0 0 16.67%')};
    }
  }

  @media (min-width: 992px) {
    ${Col} + ${Col} {
      flex: 0 0 16.67%;
      max-width: 16.67%;
    }
  }
`

export default FooterBackground
